function sectionRedering() {
  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-drawer__main", cart__html);
      $(".cart-drawer__main").replaceWith(render__html);
      var render__html = $(".cart-drawer__total-price-wrap p", cart__html);
      $(".cart-drawer__total-price-wrap p").replaceWith(render__html);
      var render__html = $(".cart-drawer__top-text p", cart__html);
      $(".cart-drawer__top-text p").replaceWith(render__html);

    });

  // header 
  // header section 
  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__cart p em", cart__html);
      $(".header__cart p em").replaceWith(render__html);
    });

}

function addToCartPro(event, element) {
  event.preventDefault();
  const variantId = $(element).attr('data-product-id');
  const data = {
    id: variantId,
    quantity: 1
  };

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (response) {
      sectionRedering();
      $("body").addClass("cart-open");
      $(".overlay").addClass("active");

    },
    error: function (xhr, status, error) {
      console.error("Error adding to cart:", error);
    }
  });
}

// Save cart note
$(document).on("input", "#CartNote", function () {

  clearTimeout(window.cartNoteTimeout);

  const note = $(this).val().toLowerCase();

  window.cartNoteTimeout = setTimeout(function () {

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      contentType: "application/json",
      data: JSON.stringify({
        note: note
      }),
      success: function () {
        console.log("Cart note saved");
      },
      error: function () {
        console.log("Failed to save cart note");
      }
    });

  }, 400);

});

$(".product-btn-add").on("click", function (e) {

  e.preventDefault();
  formData = $(this).closest(".single__product-add-pro").serialize();
  addToCart(formData)
})

function addToCart(formData) {
  console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      console.log(data)
      sectionRedering();
      $("body").addClass("cart-open");
      $(".overlay").addClass("active");
    },
    error: function (err) {
      console.log(err);
    },
  });
}

function increment_p(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
}

function decrement_p(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 1) {
    value = isNaN(value) ? 1 : value;
    value--;
    input.value = value;
  }
}












// increment quantity in cart drawer
function increment(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);

}
// decrement quantity in cart drawer
function decrement(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {

  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      sectionRedering();
    },
    error: function (err) {
      console.log("Error from quantity update")
    }
  })


}


function removeItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");
  console.log(data_line)
  var deleteData = {
    "line": data_line,
    "quantity": 0
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {

      sectionRedering();
    }
  })
}